import React from "react";
import { cn } from "../lib";

export interface InputProps
	extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(function Input(
	{ className, type, ...props },
	ref,
) {
	return (
		<input
			ref={ref}
			type={type}
			className={cn(
				/** Keep ≥16px (text-base) — iOS Safari focus-zooms smaller controls; landscape iPhone hits `md`. */
				"flex h-9 w-full rounded-md bg-card shadow-xs border border-input px-3 py-1 text-base transition-colors file:border-0 file:bg-transparent file:font-medium file:text-sm placeholder:text-foreground/60 focus-visible:outline-hidden focus-visible:ring-1 focus-visible:border-ring focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
				className,
			)}
			{...props}
		/>
	);
});

export { Input };
